// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.element-formula[data-v-8f43b8be] {\r\n  height: 100%;\r\n  width: 100%;\r\n  background: #C4C4C4;\n}\n.formula-label[data-v-8f43b8be] {\r\n  margin: 6px 0 0;\r\n  cursor: pointer;\r\n  font-size: 12px;\n}\r\n", ""]);
// Exports
module.exports = exports;
